module.exports = __webpack_public_path__ + "static/media/logo-show-rural.dd3d8de8.png";